module.exports = {"640202001":"长胜街道","640202002":"朝阳街道","640202003":"人民路街道","640202004":"长城街道","640202005":"青山街道","640202006":"石炭井街道","640202007":"白芨沟街道","640202008":"沟口街道","640202010":"长兴街道","640202011":"锦林街道","640202100":"星海镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640202.json
// module id = 2818
// module chunks = 0